module.exports = __webpack_public_path__ + "img/18.3-gallery.64766d75.jpg";